import { useTheme } from "@emotion/react";
import {
  Button,
  ButtonGroup as MuiButtonGroup,
  useMediaQuery,
} from "@mui/material";
import React from "react";

const ButtonGroup = ({
  options,
  value,
  name,
  onChange,
  size = "medium",
  className,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleInpChg = (val) => {
    var e = {
      target: {
        value: val.id,
        name: name,
      },
    };
    onChange && onChange(e);
  };

  return (
    <MuiButtonGroup
      className={className || ""}
      orientation={isMobile ? "vertical" : "horizontal"}
      fullWidth
      size={size}
    >
      {options.map((item, ind) => (
        <Button
          key={ind}
          onClick={() => handleInpChg(item)}
          variant={`${item.id === value ? "contained" : "outlined"}`}
        >
          {item.label}
        </Button>
      ))}
    </MuiButtonGroup>
  );
};

export default ButtonGroup;
